import { render, staticRenderFns } from "./EditarAditivoContrato.vue?vue&type=template&id=68534b41"
import script from "./EditarAditivoContrato.vue?vue&type=script&lang=ts"
export * from "./EditarAditivoContrato.vue?vue&type=script&lang=ts"
import style0 from "./EditarAditivoContrato.vue?vue&type=style&index=0&id=68534b41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports